/* CTA de la landing de Balsamo Apolo (barba).
   Mecanismo reusado tal cual del que ya funciona en Drenaje Linfatico (dl-cta.js,
   corregido 2026-08-09/12 tras medir el bug de doble click). Primero SIEMPRE se
   salta de forma instantanea a la zona de compra; despues, aparte, se intenta abrir
   el formulario de Releasit con un solo click real + verificacion de campos. */
(function () {
  if (window.__baJump) return;
  window.__baJump = 1;

  var SEL_RSI = '#_rsi-buy-now-button,[id*="rsi-buy-now"],[class*="_rsi-buy-now"],' +
                '[data-rsi-buy-now],.rsi-buy-now-button';

  function boton() {
    var lista = document.querySelectorAll(SEL_RSI);
    for (var i = 0; i < lista.length; i++) {
      var b = lista[i];
      if (b.offsetParent !== null || b.getClientRects().length) return b;
    }
    return lista[0] || null;
  }

  function destino() {
    return boton() ||
           document.querySelector('form[action*="/cart/add"]') ||
           document.querySelector('.product__info-wrapper');
  }

  function saltar() {
    var t = destino();
    if (!t) return;
    var y = t.getBoundingClientRect().top + window.pageYOffset - 120;
    if (y < 0) y = 0;
    var h = document.documentElement, prev = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    try { window.scrollTo({ top: y, behavior: 'instant' }); }
    catch (e) { window.scrollTo(0, y); }
    h.style.scrollBehavior = prev;
  }

  function campos() {
    var l = document.querySelectorAll(
      'input[type="text"],input[type="tel"],input[type="email"],textarea,' +
      '[id*="rsi"] input,[class*="_rsi"] input');
    var n = 0;
    for (var i = 0; i < l.length; i++) if (l[i].offsetParent !== null) n++;
    return n;
  }

  function abrir(intento) {
    var b = boton();
    if (!b) {
      if ((intento || 0) < 5) setTimeout(function () { abrir((intento || 0) + 1); }, 200);
      return;
    }
    var antes = campos();
    try { b.click(); } catch (e) {}
    setTimeout(function () {
      if (campos() > antes) return;
      try {
        b.dispatchEvent(new MouseEvent('click',
          { bubbles: true, cancelable: true, view: window }));
      } catch (e) {}
    }, 300);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var b = e.target.closest('[data-ba-jump]');
    if (!b) return;
    e.preventDefault();
    saltar();
    abrir(0);
  }, true);
})();
